module.exports = __webpack_public_path__ + "static/media/slider-1.73979fb3.jpg";